import React from "react";
import ReactDOM from "react-dom";

// FontAwesome 5 — bundled by webpack, no CDN, no manual file copy.
// Includes all `fa-*` icons used across SocialMedia, the page-up arrow,
// skill icons, etc.
import "@fortawesome/fontawesome-free/css/all.min.css";

import "./index.css";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
